import React from 'react';
import { useTranslate } from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  outerTitle: { userSelect: 'all', cursor: 'default' },
  title: {},
  subtitle: { fontSize: 'medium', opacity: 0.8 },
};

const CustomTitle = withStyles(styles)(
  ({ classes, record, title, subTitle = '' }) => {
    if (!record) {
      return null;
    }
    const translate = useTranslate();
    return (
      <span className={classes.outerTitle}>
        <span className={classes.title}>{translate(title, record)} </span>
        <span className={classes.subtitle}>{translate(subTitle, record)}</span>
      </span>
    );
  },
);

export default CustomTitle;
